export function getOtherModalCount(heightPx: number): number {
    if (heightPx <= 720) return 5;
    if (heightPx <= 760) return 4;
    if (heightPx <= 800) return 3;
    if (heightPx <= 840) return 2;
    if (heightPx <= 880) return 1;
    return 0;
}
